module.exports = ".book-list-title {\n    padding: 10px;\n\n}"